import styled from "styled-components";

const FormContainer = styled.div`
  padding-bottom: 32px;
  margin-bottom: 32px;

  h4 {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 24px;
    color: black !important;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export default FormContainer;
